<template>
    <!--Start Navbar-->
    <nav class="navbar navbar-expand-lg fixed-top custom-nav sticky">
        <div class="container">
            <!-- LOGO -->
            <router-link class="navbar-brand brand-logo mr-4" to="/">
                <img src="assets/images/logo.png" class="img-fluid logo-light" alt="">
                <img src="assets/images/logo-dark.png" class="img-fluid logo-dark" alt="">
            </router-link>
            <div class="navbar-collapse collapse justify-content-center" id="navbarCollapse">
                <ul class="navbar-nav navbar-center" id="mySidenav">
                    <li class="nav-item">
                        <router-link class="nav-link m-close-menu" to="/">Home</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link m-close-menu" to="/about">About Us</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link m-close-menu" to="/features">Features</router-link>
                    </li>
                    <li class="nav-item dropdown">
                        <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">Portfolio</a>
                        <ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/portfolioTwo">2 Column</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/portfolioThree">3 Column</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/portfolioFour">4 Column</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/blog">Blog</router-link>
                    </li>
                    <li class="nav-item dropdown">
                        <a href="javascript:void(0)" class="nav-link dropdown-toggle" target="_blank" data-toggle="dropdown">Pages</a>
                        <ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/login">Login</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/register">Register</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/blogdetail">Blog Detail</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link m-close-menu" to="/faq">FAQ</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" to="/404">404</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="contact_btn">
                <router-link class="btn btn-sm m-close-menu" to="/contact">CONTACT US</router-link>
                <button class="navbar-toggler ml-2 p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="mdi mdi-menu"></i>
                </button>
            </div>
        </div>
    </nav>
    <!-- End Navbar -->
</template>

<script>
    export default {
        name: "medpill_header",
        methods: {
        }
    }</script>